import { BaseField } from "./base";
import Mustache from "mustache";

export class LiveHtmlField extends BaseField {
	constructor(field, form) {
		super(field, form);
		this.container = this.setupContainer();
	}

	init() {
		this.render();
		// Update on form changes
		this.form.addEventListener("input", () => this.render());
	}

	setupContainer() {
		let container = this.field;
		// If field is wrapped in a form-group div, use that as container
		if (
			this.field.parentElement &&
			this.field.parentElement.classList.contains("form-group")
		) {
			container = this.field.parentElement;
		} else {
			// Otherwise create a new div to replace the field
			const newDiv = document.createElement("div");
			newDiv.classList.add("dtb-live-html");
			this.field.replaceWith(newDiv);
			container = newDiv;
		}
		return container;
	}

	render() {
		const fd = new FormData(this.form);
		const data = {};
		fd.forEach((value, key) => {
			data[key] = value;
		});
		this.container.innerHTML = Mustache.render(
			this.field.dataset.liveHtml,
			{ form: data },
		);
	}
}
